// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1jbSV","left":"StickyBox_left__206fJ","right":"StickyBox_right__1TIro"};